export default __webpack_public_path__ + "static/media/ipLogo.b60e1906.png";